import { Box } from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import React from "react";
const OptionalLink = ({ children, link, title, }) => !!link ? (React.createElement(Link, { passHref: true, href: link, title: title }, children)) : (React.createElement(React.Fragment, null, children));
export const ProductImage = ({ alt, link, src, title }) => {
    return (React.createElement(Box, { sx: {
            display: "flex",
            filter: "drop-shadow(0px 20px 46px #882727cc)",
            flexShrink: 0,
            maxWidth: { xs: "80%", sm: "55%", md: "40%" },
            mx: { xs: "auto", sm: "auto", md: 0 },
            position: "relative",
            width: "100%",
        } },
        React.createElement(OptionalLink, { link: link, title: title },
            React.createElement(Image, { alt: alt, placeholder: "blur", sizes: "35vw", src: src, title: title, style: { maxWidth: "100%", height: "auto" } }))));
};
//# sourceMappingURL=product-image.js.map